// src/components/utils/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation(); // Récupère le chemin actuel de l'URL

  useEffect(() => {
    // Fait défiler la fenêtre vers le haut (0, 0) uniquement pour les routes publiques
    // Garde la position de scroll dans l'admin et dans l'espace client
    const isAdmin = pathname && pathname.startsWith('/admin');
    const isClientSubRoute = pathname && pathname.startsWith('/mon-compte/') && pathname !== '/mon-compte/';
    if (!isAdmin && !isClientSubRoute) window.scrollTo(0, 0);
  }, [pathname]); // L'effet se redéclenche uniquement si pathname change

  return null; // Ce composant ne rend rien visuellement
}

export default ScrollToTop;

